<div class="fd-header">
  <div class="fd-header__icon-wrap">
    <mat-icon>create_new_folder</mat-icon>
  </div>
  <div style="flex:1">
    <h2 mat-dialog-title class="fd-header__title">Nueva carpeta</h2>
    <p class="fd-header__sub">Introduce el nombre para la nueva carpeta</p>
  </div>
  <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar" style="flex-shrink:0;margin-left:8px">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="fd-content">
  <div class="fd-error" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error_msg }}</span>
  </div>

  <mat-form-field appearance="outline" class="fd-field">
    <mat-label>Nombre de la carpeta</mat-label>
    <mat-icon matPrefix>folder_open</mat-icon>
    <input matInput [(ngModel)]="directory" placeholder="Mi carpeta" required />
  </mat-form-field>

  <div class="fd-success" *ngIf="done">
    <mat-icon>check_circle</mat-icon>
    <span>Carpeta creada correctamente</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="fd-actions">
  <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
  <button mat-flat-button class="fd-btn-create" (click)="createDirectory()"
          *ngIf="!done" [disabled]="!directory">
    <mat-icon>create_new_folder</mat-icon>
    Crear
  </button>
</mat-dialog-actions>
